import { useEffect, useState } from 'react';

import {
  getMessages,
  isLocaleLoaded,
  loadLocale,
  type SupportedLanguage,
} from '../loadLocale';

type LocaleMessages = Record<string, string>;

interface UseAsyncLanguageLoaderResult {
  messages: LocaleMessages;
  isLoading: boolean;
}

export const useAsyncLanguageLoader = (
  language: SupportedLanguage,
): UseAsyncLanguageLoaderResult => {
  const [messages, setMessages] = useState(() => getMessages(language));
  const [isLoading, setIsLoading] = useState(() => !isLocaleLoaded(language));

  useEffect(() => {
    if (isLocaleLoaded(language)) {
      setMessages(getMessages(language));
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    loadLocale(language)
      .then((loadedMessages) => {
        setMessages(loadedMessages);
      })
      .catch(() => {
        setMessages(getMessages(language));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [language]);

  return { messages, isLoading };
};
